export default {
    title: "Zamówienie w imieniu",
    model: {
        email: {
            label: "E-mail",
            placeholder: "Proszę wpisać nazwę użytkownika lub adres e-mail",
            notFound: "Nie znaleziono użytkowników",
            errors: {
                myself: "Adres e-mail musi różnić się od Twojego"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Składać",
            processing: "Przedkładający"
        }
    },
    error: {
        userNotExists: "{email} nie istnieje",
        country: {
            default: "OI jest obecnie niedostępny w kraju użytkownika",
            ALPHA3: ""
        }
    }
}